/* ========================================================================
 * .noConflict()
 * Enclosed everything within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
    /// is onscreen function
    $.fn.isOnScreen = function () {

        var win = $(window);

        var viewport = {
            top: win.scrollTop(),
            left: win.scrollLeft()
        };

        viewport.right = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height();

        var bounds = this.offset();
        bounds.right = bounds.left + this.outerWidth();
        bounds.bottom = bounds.top + this.outerHeight();

        return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

    };



    /// load foundation
    $(document).foundation();

    var scrollTimeout;
    var throttle = 50;

    function scroll_function(scroll) {
        if (scroll > 1) {
            $('.navbar').addClass('scroll');
            $('.usps-nav').addClass('scroll');
        } else {
            $('.navbar').removeClass('scroll');
            $('.usps-nav').removeClass('scroll');
        }

        if (!scrollTimeout) {
            scrollTimeout = setTimeout(function () {
                var st = $(this).scrollTop();

                checkDivs();

                scrollTimeout = null;
            }, throttle);
        }

        lazy();
    }

    scroll_function($(window).scrollTop());

    $(window).on('scroll', function () {
        var scroll = $(this).scrollTop();
        scroll_function(scroll);
    });

    function lazy() {
        $('img.lazy').each(function () {
            if ($(this).isOnScreen()) {
                $(this).attr('src', $(this).attr('data-src'));
                $(this).removeClass('lazy');

                if ($(this).parent().hasClass('liquid')) {
                    $(this).parent().css('background-image', 'url(' + $(this).attr('data-src') + ')');
                }
            }
        });
    }

    lazy();

    var checkDivs = function () {
        $('.anim.start').each(function () {
            if ($(this).isOnScreen() === true) {
                var anim = $(this).attr('data-anim');
                var speed = $(this).attr('data-speed');
                var delay = $(this).attr('data-delay');

                if (speed === null) {
                    speed = 500;
                }

                if (anim === 'fadeUp') {
                    $(this).velocity({translateZ: 0, translateY: '-30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateY: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeDown') {
                    $(this).velocity({translateZ: 0, translateY: '30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateY: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeLeft') {
                    $(this).velocity({translateZ: 0, translateX: '-30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateX: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeRight') {
                    $(this).velocity({translateZ: 0, translateX: '30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateX: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeIn') {
                    $(this).velocity({opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({opacity: 1}, {duration: speed, delay: delay});
                }

            }
        });
    };

    $('.anim').each(function () {
        $(this).addClass('start').css('opacity', 0);
    });

    $( "#clubInput" ).keyup(function() {
        if($(this).val().length > 3){

            $('#bedrijf-aanvraag').val($(this).val());

            var request = $.ajax({
                url: theme_directory + "/ajax/clubCheck.php",
                method: "POST",
                data: {data: $(this).val()},
                dataType: "html"
            });

            request.done(function (output) {
                $('.absolute-input').html(' ');
                $('.absolute-input').show(' ');
               var result = JSON.parse(output);

                result.forEach(function(element) {
                    $('.absolute-input').append('<li class="li-club" id="'+element+'">'+element+'</li>');
                });
            });

            request.fail(function (jqXHR, textStatus) {
                alert("Er gaat iets niet goed, neem contact met ons op.");
            });

        }
    });

    $( ".absolute-input" ).on( "click", "li", function( event ) {
        $('.absolute-input').hide();
        $('#clubInput').val(($(this).attr('id')));
    });

    function submitClub(){
        $('.absolute-input').hide();

        var val = $('#clubInput').val();

        var request = $.ajax({
            url: theme_directory + "/ajax/clubCheckButton.php",
            method: "POST",
            data: {data: val},
            dataType: "html"
        });

        request.done(function (output) {
            $('#clubInput').removeClass('green');
            $('#clubInput').removeClass('red');
            $('.absolute-input').hide();

            if(output === 'true'){
                $('#clubInput').addClass('green');
                $('.checktoggle').addClass('fa-check');
                $('.checktoggle').removeClass('fa-times');
                $('.checktoggle').addClass('active');
            }else{
                $('.club-update').fadeIn();
                $('#clubInput').addClass('red');
                $('.checktoggle').addClass('fa-times');
                $('.checktoggle').removeClass('fa-check');
                $('.checktoggle').addClass('active');
            }
        });

        request.fail(function (jqXHR, textStatus) {
            alert("Er gaat iets niet goed, neem contact met ons op.");
        });

        $('.absolute-input').hide();

        setTimeout(function(){
            $('.absolute-input').hide();
        }, 2000)
    }

    $('#checkClub').click(function(){
       submitClub();
    });

    $('section').click(function(){
        $('.absolute-input').hide();
    });

    $('.switcha').click(function(e){
        e.preventDefault();
       toggleSwitch();
    });

    $('.update-close').click(function(){
       $('.club-update').fadeOut();
    });

    $('.how-to-items li').click(function(){
        var itemclass = $(this).attr('class');

        stoploop = true;

        if(!$(this).hasClass('active')){
            $('.how-to-items').find('.active').removeClass('active');

            if(itemclass === 'how-to-1'){
                $('.how-to-1').addClass('active');
            }else if(itemclass === 'how-to-2'){
                $('.how-to-2').addClass('active');
            } else if(itemclass === 'how-to-3'){
                $('.how-to-3').addClass('active');
            }else if(itemclass === 'how-to-4'){
                $('.how-to-4').addClass('active');
            }else if(itemclass === 'how-to-5'){
                $('.how-to-5').addClass('active');
            }else if(itemclass === 'how-to-6'){
                $('.how-to-6').addClass('active');
            }else if(itemclass === 'how-to-7'){
                $('.how-to-7').addClass('active');
            }else if(itemclass === 'how-to-8'){
                $('.how-to-8').addClass('active');
            }else if(itemclass === 'how-to-9'){
                $('.how-to-9').addClass('active');
            }else if(itemclass === 'how-to-10'){
                $('.how-to-10').addClass('active');
            }

            if ($(window).width() < 866) {
                $('html, body').animate({
                    scrollTop: $(".steps-phone").offset().top - 120
                }, 1300);
            }
        }
    });

    function getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    $('#clubInput').on('keyup keypress', function(e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
            submitClub();

            e.preventDefault();
            return false;
        }
    });

    function toggleSwitch(){



        $('.headerclass').toggleClass('zakelijk');

        if($('.logo-normal').hasClass('active')){
            $('.logo-normal').removeClass('active');
            $('.logo-neg').addClass('active');
        }else{
            $('.logo-normal').addClass('active');
            $('.logo-neg').removeClass('active');
        }

        setTimeout(function(){window.location.replace(otherURL);  $('.white-overlay').fadeIn(300);},500);

          //window.location.replace(otherURL);
    }

    $('.mobile-menu').click(function () {
        var $overlay = $('.dark-overlay'),
            $hamburger = $('.hamburger'),
            $menu = $('.header__menu');

        $hamburger.toggleClass('is-active').toggleClass('fixed');

        $menu.toggleClass('show');
        $overlay.fadeToggle();
    });

    $('.dark-overlay').click(function () {
        var $this = $(this),
            $hamburger = $('.hamburger'),
            $menu = $('.header__menu');

        $this.fadeOut();
        $hamburger.toggleClass('is-active').toggleClass('fixed');
        $menu.toggleClass('show');
    });

    // Tabs
    $('.activator').on('click', function(){
        if($(this).hasClass('active')){
            $(this).removeClass('active');
        } else {
            $(this).addClass('active');
        }
    });

    $('.single-post-title').click(function(){
        $(this).toggleClass('active');
       $(this).parent().find('.single-post-content').slideToggle();

       if($(this).parent().find('.fa').hasClass('fa-plus')){
           $(this).parent().find('.fa').removeClass('fa-plus');
           $(this).parent().find('.fa').addClass('fa-minus');
       }else{
           $(this).parent().find('.fa').removeClass('fa-minus');
           $(this).parent().find('.fa').addClass('fa-plus');
       }

    });

    $('#blogSearchButton').click(function(){
       var value = '?s=' + $('#blog-search').val();
       var select = '?cat=' +  $( ".cat-select option:selected" ).val();

       var url = blogUrl;

       if(value.length > 5){
           url = url + value;
       }

       if($( ".cat-select option:selected" ).val() != '0'){
           url = url + select;
       }

        window.location.href = url;

    });

    $('.popup-open').click(function(e){
        e.preventDefault();
        $('.contact-popup').fadeIn();
    });

    $('.nieuwsbrief-open').click(function(e){
        e.preventDefault();
       $('.nieuwsbrief-popup').fadeIn();
    });

    $('.nieuwsbrief-popup').find('input[type=checkbox]').click(function(){
       $(this).toggleClass('bgpurple');
    });

    $('.form-open').click(function(e){
        e.preventDefault();
        $('.form-popup').fadeIn();
    });

    function getMobileOperatingSystem() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
            $('.ios').hide();
            return "Android";
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            $('.android').hide();
            return "iOS";
        }

        return "unknown";
    }

    getMobileOperatingSystem();

    $('.wat-levert-het-op').click(function(e){
        e.preventDefault();
        $('.wat-levert-het-op-popup').fadeIn();
    });

    $('.overlay-form').click(function(){
        $('.contact-popup').fadeOut();
        $('.nieuwsbrief-popup').fadeOut();
        $('.form-popup').fadeOut();
        $('.wat-levert-het-op-popup').fadeOut();
    });

    $('.popup-close').click(function(){
       $('.contact-popup').fadeOut();
       $('.nieuwsbrief-popup').fadeOut();
       $('.form-popup').fadeOut();
       $('.wat-levert-het-op-popup').fadeOut();
    });

    $('.content-mh').matchHeight();
    $('.title-mh').matchHeight();
    $('.cta-mh').matchHeight();
    $('.ctap-mh').matchHeight();
    $('.cta2-mh').matchHeight();
    $('.mh-img-part').matchHeight();
    $('.mh-p-part').matchHeight();

    $('.checkbox label').click(function(){
        toggleSwitch();
    });

    $('.bedrijven-slider').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        autoplaySpeed: 2100,
        autoplay: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    });

    if (window.matchMedia("(max-width: 577px)").matches) {
        /* the viewport is less than 768 pixels wide */

        $('.partnersSlider').slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplaySpeed: 2100,
            autoplay: true,
        });

    }

    if (window.matchMedia("(max-width: 768px)").matches) {
        /* the viewport is less than 768 pixels wide */

        $('.soort-bedrijven-slider').slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplaySpeed: 2100,
            autoplay: true,
        });
    }

    $('.review-slider').slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 805,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    autoplaySpeed: 2700,
                    autoplay: true,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplaySpeed: 2700,
                    autoplay: true,
                    dots: true
                }
            }
        ]
    });


    var loop = 0;
    var count = $('.steps-phone').find('img').length;
    var stoploop = false;

    function nextLoop(loop){

        if(!stoploop){
            setTimeout(function(){
                shift(loop);
            }, 2500);
        }

    }

    nextLoop(loop);

    function shift(loop){
        if(!stoploop){
            $('.how-to-1').removeClass('active');
            $('.how-to-2').removeClass('active');
            $('.how-to-3').removeClass('active');
            $('.how-to-4').removeClass('active');
            $('.how-to-5').removeClass('active');
            $('.how-to-6').removeClass('active');
            $('.how-to-7').removeClass('active');
            $('.how-to-8').removeClass('active');
            $('.how-to-9').removeClass('active');
            $('.how-to-10').removeClass('active');


            if(loop < count - 1){
                loop = loop + 1;
                $(".steps-phone").find('img').eq(loop).addClass('active');
                $(".steps-text").find('li').eq(loop).addClass('active');
                nextLoop(loop);
            }else{
                loop = 0;
                nextLoop(loop);
                $(".steps-phone").find('img').eq(loop).addClass('active');
                $(".steps-text").find('li').eq(loop).addClass('active');
            }
        }
    }
    
    if (document.referrer.indexOf("support") >= 0){
        if (window.location.href .indexOf("support") >= 0){
            $('html, body').animate({
                scrollTop: $("section.support").offset().top - 60
            }, 500);
        }
    }

    $('.liquid').imgLiquid();

    $('.white-overlay').fadeOut();

})(jQuery); // Fully reference jQuery after this point.